<template>
    <div class="banner_box">
      <van-swipe :show-indicators='false' class="banner_box_swipe">
        <van-swipe-item>
          <!-- <img src="../../assets/images/home_bg_banner.png"/> -->
          <img src="../../assets/images/home_bg_banner2.png"/>
          <!-- <div class="banner_box_swipe_text">
            <p>加入高德官方合作</p>
            <p>代驾平台</p>
          </div> -->
        </van-swipe-item>
      </van-swipe>
    </div>
</template>

<script>
export default {

}
</script>

<style lang='less' scoped>
.banner_box{
  .banner_box_swipe{
    height: 320px;
    position: relative;
    img{
      width: 100%;
    }
    .banner_box_swipe_text{
      width: 480px;
      position: absolute;
      left: 50%;
      margin-left: -230px;
      top: 50%;
      margin-top:-80px;
      font-size: 60px;
      color: #FFFFFF;
      text-align: center;
      font-weight: bold;
      p:nth-of-type(2){
        font-size: 40px;
      }
    }
  }
}
</style>
